import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { PVHOrdersEntity } from "../entities/pvh-orders.entity";
import { PvhOrderFilter } from "packages/libs/shared-models/src/common/pvh/pvh-order-filter";
import { ExternalReq } from "@project-management-system/shared-models";



@Injectable()
export class PVHOrdersRepository extends Repository<PVHOrdersEntity> {

    constructor(@InjectRepository(PVHOrdersEntity) private PvhOrdersRepo: Repository<PVHOrdersEntity>
    ) {
        super(PvhOrdersRepo.target, PvhOrdersRepo.manager, PvhOrdersRepo.queryRunner);
    }

    async getorderDataForInfo(req?: PvhOrderFilter): Promise<any[]> {
        console.log(req)
        const query = this.createQueryBuilder('o')
            .select(`*`)
            if (req?.poNumber !== undefined) {
                const poNumbers = req.poNumber.split(',').map(poNumber => poNumber.trim());
                query.andWhere(`o.po_number IN (:...poNumbers)`, { poNumbers });
            }
        // if (req.color !== undefined) {
        //     query.andWhere(`o.color LIKE :color`, { color: `%${req.color}%` });
        // }
        if (req?.deliveryDateStartDate !== undefined && req?.deliveryDateEndDate !== undefined) {
            query.andWhere(`STR_TO_DATE(o.delivery_date, '%d/%m/%Y') BETWEEN STR_TO_DATE(:startDate, '%d/%m/%Y') AND STR_TO_DATE(:endDate, '%d/%m/%Y')`, {
                startDate: req.deliveryDateStartDate,
                endDate: req.deliveryDateEndDate
            });
        }
        if (req.externalRefNo !== undefined) {
            query.andWhere(`o.buyer_name ='${req.externalRefNo}'`)
        }
        query.andWhere(`o.status != 'ACCEPTED'`);

        return await query.getRawMany()
    }

    // async getPoNumber(req?:ExternalReq): Promise<any[]> {
    //     console.log(req,"reqpo")
    //     const query = this.createQueryBuilder('o')
    //         .select(`DISTINCT po_number`)
    //         if (req.externalRef !== undefined || req.externalRef == ''){
    //             query.andWhere(`o.buyer_name ='${req.externalRef}'`)
    //         }


    //     return await query.getRawMany()
    // }

    async getPoNumber(req?: ExternalReq): Promise<any[]> {
        console.log(req, "reqpo");

        const query = this.createQueryBuilder('o')
            .select(`DISTINCT po_number`);

       

        if (req.externalRef === '') {
            // If req.externalRef is undefined or empty, fetch all data
            // No need to add any conditions to the query
        } else if (req.externalRef !== undefined) {
            // If req.externalRef is defined and not empty, add it as a condition
            query.andWhere(`o.buyer_name = :externalRef`, { externalRef: req.externalRef });
        }

        //  if (req?.poNumber !== undefined) {
        //     query.andWhere(`orders.po_number IN (:...poNumber)`, { poNumber: req.poNumber })
        // }

        return await query.getRawMany();
    }


    async getorderacceptanceData(req?: PvhOrderFilter): Promise<any[]> {
        console.log(req,'repo');
        const query = this.createQueryBuilder('o')
            .select('*');
            
        if (req?.poNumber !== undefined) {
            const poNumbers = req.poNumber.split(',').map(poNumber => poNumber.trim());
            query.andWhere(`o.po_number IN (:...poNumbers)`, { poNumbers });
        }
    
        if (req?.deliveryDateStartDate !== undefined && req?.deliveryDateEndDate !== undefined) {
            query.andWhere(`STR_TO_DATE(o.delivery_date, '%d/%m/%Y') BETWEEN STR_TO_DATE(:startDate, '%d/%m/%Y') AND STR_TO_DATE(:endDate, '%d/%m/%Y')`, {
                startDate: req.deliveryDateStartDate,
                endDate: req.deliveryDateEndDate
            });
        }
    
        // if (req?.externalRefNo !== undefined ) {
        //     query.andWhere(`o.buyer_name ='${req.externalRefNo}'`);
        // }
        // if (req?.externalRefNo === "CKNorthAmerica" ) {
        //     query.andWhere(`o.buyer_name ='${req.externalRefNo}'`);
        // }

        // if (req?.externalRefNo === "CKEurope" ) {
        //     query.andWhere(`o.buyer_name ='${req.externalRefNo}'`);
        // }

        
        if (req?.externalRefNo === "CKNorthAmerica") {
            query.andWhere(`o.buyer_save_name ='CK'`);

        } 
        if (req?.externalRefNo === "CKEurope") {
            query.andWhere(`o.buyer_save_name ='CK'`);

        } 

        if (req?.externalRefNo === "TommyNorthAmerica") {
            query.andWhere(`o.buyer_save_name ='TH'`);

        } 

        if (req?.externalRefNo === "TommyEurope"  ) {
            query.andWhere(`o.buyer_save_name ='TH'`);
        } 


        query.andWhere(`o.status != 'ACCEPTED'`);
    
        return await query.getRawMany();
    }
    

    async getordercomparationData(req?: PvhOrderFilter): Promise<any[]> {
        const query = this.createQueryBuilder('o')
            .select(`*`)
        if (req.poNumber !== undefined) {
            query.andWhere(`o.po_number ='${req.poNumber}'`)
        }
        if (req.externalRefNo !== undefined) {
            query.andWhere(`o.buyer_name ='${req.externalRefNo}'`)
        }

        return await query.getRawMany()
    }

}